module.exports = __webpack_public_path__ + "img/check.3be16f20.svg";